<template>
  <v-app>
    <v-container class="pt-10">
      <v-card flat>
        <v-card-title class="text-h4">
          Dispositivo não autorizado
        </v-card-title>

        <v-card-text>
          Solicite a um administrador para autorizar o dispositivo atual

          <v-simple-table
            v-if="deviceId"
            style="width: 100%"
            class="mt-5"
            dense
          >
            <tbody>
              <tr>
                <th width="130px">ID</th>
                <td v-text="deviceId"></td>
              </tr>
              <tr>
                <th width="130px">Dispositivo</th>
                <td v-text="deviceName"></td>
              </tr>
              <tr>
                <th width="130px">Status</th>
                <td>Não autorizado</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions class="mt-5">
          <v-btn
            v-if="deviceId"
            @click="verityDevice()"
            large
            color="primary"
            class="px-4 mx-2"
            :loading="refreshing"
          >
            Atualizar
          </v-btn>
          <v-btn
            v-else
            @click="requestSolicitation()"
            large
            color="primary"
            class="px-4 mx-2"
          >
            Solicitar autorização
          </v-btn>
          <v-btn :to="{ name: 'login' }" large color="primary" text>
            Sair
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      deviceId: null,
      deviceName: "",
      deviceCode: "",
      authorized: false,
      refreshing: false
    };
  },

  methods: {
    async requestSolicitation() {
      if (this.deviceId) {
        return;
      }

      const deviceName = this.random(7);
      const code = this.random();

      const response = await this.$http.post("/authorized_devices/request", {
        device_name: deviceName,
        code
      });

      this.deviceName = deviceName;
      this.deviceCode = code;
      this.deviceId = response.data.data.id;
      localStorage.setItem("device_id", response.data.data.id);
      localStorage.setItem("device_name", response.data.data.name);
      localStorage.setItem("device_code", code);

      if (response.data.data.authorized) {
        this.$router.replace("/");
      }
    },

    async verityDevice() {
      this.refreshing = true;
      const device = this.getDevice();
      try {
        const response = await this.$http.post("/authorized_devices/check", {
          id: device.id,
          code: device.code
        });

        this.authorized = response.data.data.approved;

        if (response.data.data.approved) {
          this.$router.replace("/");
          return;
        }
      } catch (error) {
        if (error.response.status === 404) {
          this.setDevice(null, null, null);
        }
      } finally {
        this.refreshing = false;
      }
    },

    getDevice() {
      return {
        id: localStorage.getItem("device_id"),
        name: localStorage.getItem("device_name"),
        code: localStorage.getItem("device_code")
      };
    },

    setDevice(id, name, code) {
      localStorage.setItem("device_id", id);
      localStorage.setItem("device_name", name);
      localStorage.setItem("device_code", code);
      this.deviceId = id;
      this.deviceName = name;
      this.deviceCode = code;
    },

    dec2hex(dec) {
      return dec.toString(16).padStart(2, "0");
    },

    random(len = null) {
      var arr = new Uint8Array((len || 40) / 2);
      window.crypto.getRandomValues(arr);
      return Array.from(arr, this.dec2hex).join("");
    }
  },

  created() {
    this.deviceId = localStorage.getItem("device_id");
    this.deviceName = localStorage.getItem("device_name");
    this.deviceCode = localStorage.getItem("device_code");

    this.verityDevice();
  }
};
</script>
